<template>
  <div class="lingkong-ai-page">
    <img
      class="lingkong-ai-page__poster"
      src="@/assets/image/lingkong-ai/explore-poster.png"
      alt="灵空AI"
    >
  </div>
</template>

<script>
export default {
  name: 'LingkongAi',
  created () {
    document.title = '灵空AI'
  }
}
</script>

<style scoped lang="scss">
.lingkong-ai-page {
  min-height: 100vh;
  font-size: 0;
  background: #eef7ff;
}

.lingkong-ai-page__poster {
  display: block;
  width: 100%;
  height: auto;
}
</style>
